const state = {
  info: {
    helperCaqid: '',
    questionerCaqid: '',
    unreadCount: '0',
    answeringUnreadCount: '0',
  }
}

const getters = {
}

const mutations = {
  setInfo (state, info) {
    state.info = info
  }
}

const actions = {
  init ({ state, commit, rootState }, params) {
    return rootState.axios.get('/comment/v1frontend/coin-aid-question/init', { params }).then(res => {
      commit('setInfo', res.data.model)
      return res
    })
  },
  unsolve ({ state, commit, rootState }, params) {
    return rootState.axios.get('/comment/v1frontend/coin-aid-question/unsolve', { params })
  },
  answering ({ state, commit, rootState }, params) {
    return rootState.axios.get('/comment/v1frontend/coin-aid-question/answering', { params })
  },
  details ({ state, commit, rootState }, params) {
    return rootState.axios.get('/comment/v1frontend/coin-aid-question/details', { params })
  },
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/comment/v1frontend/coin-aid-question/search', { params })
  },
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/comment/v1frontend/coin-aid-question/create', params)
  },
  view ({ state, commit, rootState }, params) {
    return rootState.axios.get('/comment/v1frontend/coin-aid-question/view', { params })
  },
  updateDone ({ state, commit, rootState }, params) {
    return rootState.axios.post('/comment/v1frontend/coin-aid-question/update-done', params)
  },
  updateScore ({ state, commit, rootState }, params) {
    return rootState.axios.post('/comment/v1frontend/coin-aid-question/update-score', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
